export default __webpack_public_path__ + "static/media/skip-character.ed4bdfde.png";